import React from 'react';

import baseStyles from 'components/Layouts/Form/Header/index.module.css';
import Burger from 'components/shared/Burger';
import Logo from 'components/shared/Icon/icons/Logo';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './index.module.css';
import Links from './Links';

const Main = (props) => {
  const { backLink, links } = props;
  const { isTabletOrMobile } = useMediaBreakpoints();

  if (isTabletOrMobile) {
    return (
      <div className={s.wrapper}>
        <div className={s.top}>
          <div>{backLink}</div>
          <Logo width="9.8rem" height="3rem" className={s.logo} />

          <Burger />
        </div>

        {links && <Links links={links} />}
      </div>
    );
  }

  return (
    <>
      <div style={{ width: '50%' }}>{backLink}</div>

      <div className={baseStyles.linksWrap}>{links}</div>
    </>
  );
};

export default Main;
